import HeroSlider from "../HeroSlider"

export const Section1 = ()=>{
  return <section>
    <HeroSlider/>
  </section>
}